__turbopack_context__.v({
  "container": "modal-selection-module-scss-module__94SIvq__container",
});
